import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const axiosInstance = axios.create({
  baseURL: "https://clevdoc-legal-cms-b25ce73f594e.herokuapp.com"
});

axiosInstance.interceptors.request.use((config) => {
  const token = cookies.get("authToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const url = config.url || "";
  const method = config.method?.toLowerCase() || "get";
  const endpoint = url.replace(/^\//, "").split("/")[0];

  let moduleId = "";

  if (endpoint === "roles") {
    moduleId = method === "get" ? "roles,cms_roles" : "roles";
  }

  if (endpoint === "cms-roles") {
    moduleId = "cms_roles";
  }

  if (endpoint === "arbitration-management") {
    moduleId = "commence"; // ✅ correct
  }

  if (endpoint === "orders") {
    moduleId = "order";
  }

  if (endpoint === "payments") {
    moduleId = "payment";
  }

  if (endpoint === "efiling") {
    moduleId = "efiling";
  }

  if (endpoint === "dashboard") {
    if (url.includes("Arbitrations")) {
      moduleId = "commence";
    } else if (url.includes("Payments")) {
      moduleId = "payment";
    } else if (url.includes("Efilings")) {
      moduleId = "efiling";
    } else if (url.includes("getAll")) {
      moduleId = "user";
    }
  }

  if (moduleId) {
    config.headers["module-id"] = moduleId;
  }

  console.log("Request config:", {
    url: config.url,
    method: config.method,
    moduleId,
    authToken: !!token,
  });

  return config;
});

export default axiosInstance;